export default "__VITE_ASSET__uHgRNpMA__"